/** @format */

import React from "react";
import { BrowserRouter } from "react-router-dom";
// import history from "./components/RouterWithAcess/history";
import "./App.css";
// import Navbar from "./components/Navbar";
import "primereact/resources/themes/nova-accent/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import AppWithRouterAccess from "./components/RouterWithAcess/AppWithRouterAccess";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
function App() {
  return (
    <div className='App'>
      <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AppWithRouterAccess />
        </QueryClientProvider>
      </BrowserRouter>
      </div>
  );
}

export default App;
